import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { CountryService } from '@core/services/CountryService';

export const list = snakeStore(
  {
    state: {
      countries: [],
      isLoading: false
    },
    mutations: {
      countries: (state, value) => {
        return (state.countries = value);
      },
      isLoading: (state, value) => {
        return (state.isLoading = value);
      }
    },

    actions: {
      getList: ({ commit, getters }) => {
        // cash
        if (getters.countries?.length <= 0) {
          commit('isLoading', true);
          return CountryService.getUserCountriesSelect()
            .then((response) => {
              commit('countries', response);
            })
            .finally(() => commit('isLoading', false));
        }
      }
    },

    getters: {
      isLoading: (state) => {
        return state.isLoading;
      },
      countries: (state) => {
        return state.countries;
      }
    }
  },
  true
);
